import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const reasons = [
  {
    title: 'Estetik = Strateji',
    description: 'Güzel görünen her şey stratejik düşünülmüştür. Tasarım sadece görsel değil, iş hedeflerinize hizmet eder.',
  },
  {
    title: 'Hızlı ama Rafine',
    description: 'Hız, kaliteden ödün vermek değildir. AI ve deneyimimizle hem hızlı hem kusursuz üretim yapıyoruz.',
  },
  {
    title: 'Kürasyon Odaklı Çalışırız',
    description: 'Her işi markanın ihtiyacına göre kurgularız. Sabit paketler yerine, doğru uzmanları ve doğru iş ortaklarını bir araya getiririz. Böylece daha rafine, daha isabetli ve markaya gerçekten ait çözümler üretiriz.',
  },
  {
    title: 'Influencer\'ı Medya Gibi Yönetiriz',
    description: 'Influencer marketing\'i şansa bırakmıyoruz. Her kampanyayı medya planı gibi tasarlıyor, ölçüyor ve optimize ediyoruz.',
  },
  {
    title: 'AI ile Ölçeklenir, İnsan Dokunuşu Korunur',
    description: 'Yapay zeka hızımızı artırır, ancak marka kimliğiniz ve yaratıcı yönünüz her zaman insan kontrolünde kalır.',
  },
];

export default function WhyNexit() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <span className="font-sans text-xs uppercase text-gray-light tracking-wider">
              FARK
            </span>
            <h2 className="font-serif text-5xl text-charcoal mt-4 mb-12">
              Neden NEXIT
            </h2>

            <div className="space-y-8">
              {reasons.map((reason, index) => (
                <motion.div
                  key={reason.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
                >
                  <h3 className="font-sans font-semibold text-lg text-charcoal mb-2">
                    {reason.title}
                  </h3>
                  <p className="font-sans text-base text-gray-medium leading-relaxed">
                    {reason.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/7a26518d9c513b178c490ad4cddec9fa.jpg"
              alt="NEXIT Workspace"
              className="w-full h-auto rounded-2xl shadow-xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
